<template>
  <div>
    <h1 style="margin-top:5%;"> Liste des boucles </h1>
    <b-row>
        <b-col sm="10"></b-col>
        <b-col sm="2" class="mb-8">
            <b-button
            size="sm"
            variant="outline-primary"
            @click="addNewLoop()"
            >Ajout d'une boucle</b-button>
        </b-col>
    </b-row>
    <div class="justify-content-md-center" style="margin-top:5%;">

        <b-table striped
                hover
                :items="loops"
                :fields="fields">
        <template v-slot:cell(Update)="row">
            <div>
            <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
            <b-button
                size="sm"
                variant="primary"
                @click="moveToUpdateView(row)"
                class="mr-2"
            >
                <i class="fa fa-refresh" aria-hidden="true"></i>
            </b-button>
            </div>
        </template>
        </b-table>
    </div>
     <NewLoopModal ref="new-loop"/>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import LoopSelector from '../kanban/LoopSelector.vue'
import NewLoopModal from '../loops/NewLoopModal.vue'

export default {
  name: 'LoopOperation',
  props: [],
  data () {
    return {
        loopsDisplay: [],
        loops: [],
        fields: [
            { key: 'name', label: 'Nom', sortable: true },
            { key: 'description', label: 'Description', sortable: true },
            { key: 'index', label: 'Index', sortable: true },
            'Update'],
    }
  },
  watch: {
      selectedLoop(newValue, oldValue) {
        if (_.isEmpty(newValue)) {
            return
        }
        this.getLoopInfos(newValue)
      }
  },
  methods: {
      getAllLoops() {
        server.getLoops().then((result) => {
          result.data.forEach(element => {
              this.loopsDisplay.push(element.description)
              this.loops.push(element)
          });
        })
      },
      addNewLoop() {
          this.$refs['new-loop'].showModal()
      },
      getLoopInfos(SelectedLoopName) {
          server.getLoopInformation(SelectedLoopName).then((result) => {
              this.loop_name = result.data.name
              this.loop_description = result.data.description
              this.loop_index = result.data.index
          })
      },
      onSubmit(evt) {
        evt.preventDefault()
        server.updateGivenLoop({'loop': this.selectedLoop, 'description': this.loop_description, 'name': this.loop_name, 'index': this.loop_index}).then(() => {
            this.makeToast("MaJ réussie !")
            this.resetValues()
        })
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.resetValues()
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
      },
      resetValues () {
          this.loop_name = ''
          this.loop_description = ''
          this.loop_index = ''
          this.selectedLoop = ''
          this.loopsDisplay = []
          this.getAllLoops()
      },
      moveToUpdateView(row) {
          this.goTo('/loop/update/' + row.item.name)
      }
  },
  mounted: function () {
      this.getAllLoops()
  },
  components: { NewLoopModal }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/settings/LoopOperations.vue